var map = {
	"./ausadhi.png": "./src/Containers/Play/HitTheWall/content/images/level1/ausadhi.png",
	"./bhakari.png": "./src/Containers/Play/HitTheWall/content/images/level1/bhakari.png",
	"./doko.png": "./src/Containers/Play/HitTheWall/content/images/level1/doko.png",
	"./haluwa.png": "./src/Containers/Play/HitTheWall/content/images/level1/haluwa.png",
	"./himal.png": "./src/Containers/Play/HitTheWall/content/images/level1/himal.png",
	"./kafal.png": "./src/Containers/Play/HitTheWall/content/images/level1/kafal.png",
	"./kamila.png": "./src/Containers/Play/HitTheWall/content/images/level1/kamila.png",
	"./lauka.png": "./src/Containers/Play/HitTheWall/content/images/level1/lauka.png",
	"./lichi.png": "./src/Containers/Play/HitTheWall/content/images/level1/lichi.png",
	"./methai.png": "./src/Containers/Play/HitTheWall/content/images/level1/methai.png",
	"./nariwol.png": "./src/Containers/Play/HitTheWall/content/images/level1/nariwol.png",
	"./pathsala.png": "./src/Containers/Play/HitTheWall/content/images/level1/pathsala.png",
	"./pipal.png": "./src/Containers/Play/HitTheWall/content/images/level1/pipal.png",
	"./taraju.png": "./src/Containers/Play/HitTheWall/content/images/level1/taraju.png",
	"./thadauro.png": "./src/Containers/Play/HitTheWall/content/images/level1/thadauro.png",
	"./wakil.png": "./src/Containers/Play/HitTheWall/content/images/level1/wakil.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Containers/Play/HitTheWall/content/images/level1 sync recursive ^\\.\\/.*$";